import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import { extractPaymentAttachmentValues } from '../../helpers/paymentAttachmentCodes'

import {
  buildNoEffectiveVisitFields,
  buildNoEffectiveVisitSummaryFields
} from './shared/noEffectiveVisitHelpers'
import NoEffectiveVisitDetailsDesktop from './desktop/NoEffectiveVisitDetailsDesktop'
import NoEffectiveVisitDetailsMobile from './mobile/NoEffectiveVisitDetailsMobile'

export default function NoEffectiveVisitModernDetailsTab({
  activity = {},
  statusUI,
  showStatusInHeader = false
}) {
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const customFields = Array.isArray(activity.custom_fields) ? activity.custom_fields : []
  const summaryFields = buildNoEffectiveVisitSummaryFields(activity)
  const fieldsToRender = buildNoEffectiveVisitFields(customFields)
  const paymentAttachments = extractPaymentAttachmentValues(customFields)

  if (isMobileLayout) {
    return (
      <NoEffectiveVisitDetailsMobile
        activity={activity}
        statusUI={statusUI}
        summaryFields={summaryFields}
        fieldsToRender={fieldsToRender}
        paymentAttachments={paymentAttachments}
      />
    )
  }

  return (
    <NoEffectiveVisitDetailsDesktop
      activity={activity}
      summaryFields={summaryFields}
      fieldsToRender={fieldsToRender}
      paymentAttachments={paymentAttachments}
    />
  )
}
